/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentMethod {
    CREDIT_CARD = 'CreditCard',
    WIRE_TRANSFER = 'WireTransfer',
    APM = 'Apm',
    SETTLEMENT_CREDIT_CARD = 'SettlementCreditCard',
    SETTLEMENT_WIRE = 'SettlementWire',
    FRAUD = 'Fraud',
    VOID = 'Void',
    RECALL = 'Recall',
    INTERNAL_TRANSFER = 'InternalTransfer',
    WD = 'Wd',
    CHARGE_BACK = 'ChargeBack',
    FEE_IN = 'FeeIn',
    INACTIVITY_FEE = 'InactivityFee',
    FEE_REVERSAL = 'FeeReversal',
    CREDIT_IN = 'CreditIn',
    CREDIT_OUT = 'CreditOut',
}
